<template>
    <div>
        <slot
            :search="search"
            :update-search="updateSearch"
        >
            <div class="form-group">
                <label for="FaqsSearchInput" v-if="label">Faqs</label>
                <input
                    class="form-control"
                    id="FaqsSearchInput"
                    placeholder="Ask a question..."
                    type="text"
                    v-model="search"
                >
            </div>
        </slot>
    </div>
</template>

<script>
//Let's see if we can refactor this so that it is reusable for other Tables.
export default {
    name: 'FaqsSearch',

    props: {
        label: {
            default: false,
            required: false,
            type: Boolean,
        },
        limit: {
            default: null,
            required: false,
            type: Number,
        },
        endpoint: {
            default: '/api/v0/faqs',
            required: false,
            type: String,
        },
    },

    data() {
        return {
            faqs: [],
            search: '',
        }
    },

    computed: {
        endpointWithQueryString() {
            let endpoint = `${this.endpoint}?question_or_answer=${this.search}`;
            if (this.limit) {
                endpoint += `&limit=${this.limit}`;
            }

            return endpoint;
        },
    },

    watch: {
        search: {
            handler: _.debounce(function () {
                this.getFaqs();
            }, 400),
        },
        faqs(newVal) {
            if (newVal) {
                this.$emit('input', newVal);
            }
        },
    },

    created() {
        this.getFaqs();
    },

    methods: {
        getFaqs() {
            axios
                .get(this.endpointWithQueryString)
                .then(res => Object.assign(this, {faqs: res.data.data.faqs}))
                .catch(err => console.error(err))
            ;
        },
        updateSearch(e) {//for use with slots, so that the slot can update the search property.
            Object.assign(this, {search: e.target.value});
        },
    },
}
</script>



// WEBPACK FOOTER //
// src/Assets/components/AAA_TO_REFACTOR/Search.vue